// extracted by mini-css-extract-plugin
export default {"description_body":"Description_description_body__vvskE","description_heading":"Description_description_heading__AXXh9"};